import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.mixin({
  methods: {
    sendEvent(name) {
      if (window.ym) {
        window.ym(95248728,'reachGoal', name)
      } else {
        console.log(window.ym)
      }
    }    
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
